import { debounce } from 'lodash';
import { FC, useEffect, useMemo } from 'react';
import SearchBar from 'components/new-ui/base/searchbar/SearchBar';

const SEARCH_DEBOUNCE_MS = 500;

interface Props {
    onSearch: (query: string) => void;
}

const TemplateSearchInput: FC<Props> = ({ onSearch }) => {
    const debouncedSearch = useMemo(() => debounce(onSearch, SEARCH_DEBOUNCE_MS), [onSearch]);

    useEffect(() => () => debouncedSearch.cancel(), [debouncedSearch]);

    return <SearchBar inputPlaceholder="Search" onChange={debouncedSearch} allowClear />;
};

export default TemplateSearchInput;
